import { useMutation, useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api/client";
import { queryClient } from "../app/queryClient";
import { Panel } from "../components/Panel";
import type { Lead } from "../types";

export function LeadsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["leads"],
    queryFn: () => apiFetch<{ data: Lead[] }>("/api/leads"),
  });
  const updateLead = useMutation({
    mutationFn: (lead: Lead) => apiFetch<{ data: Lead }>(`/api/leads/${lead.id}`, { method: "PATCH", body: lead }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["leads"] }),
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-semibold">Lead</h2>
        <p className="mt-1 text-slate-400">Contatti generati dalle conversazioni WhatsApp.</p>
      </div>

      <Panel>
        {isLoading ? (
          <p>Caricamento lead...</p>
        ) : (
          <div className="overflow-x-auto rounded-xl border border-white/10">
            <table className="w-full text-left text-sm">
              <thead className="bg-white/5 text-slate-300">
                <tr>
                  <th className="p-4">Nome</th>
                  <th className="p-4">Telefono</th>
                  <th className="p-4">Email</th>
                  <th className="p-4">Stato</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10">
                                {(data?.data ?? []).map((lead) => (
                  <tr key={lead.id}>
                    <td className="p-4">{lead.profile_name ?? "-"}</td>
                    <td className="p-4">{lead.phone}</td>
                    <td className="p-4">
                      <input
                        className="w-full rounded-lg bg-slate-900 px-3 py-2"
                        defaultValue={lead.email ?? ""}
                        onBlur={(event) => updateLead.mutate({ ...lead, email: event.target.value })}
                      />
                    </td>
                    <td className="p-4">
                      <select
                        className="rounded-lg bg-slate-900 px-3 py-2"
                        defaultValue={lead.status}
                        onChange={(event) => updateLead.mutate({ ...lead, status: event.target.value })}
                      >
                        <option value="new">new</option>
                        <option value="active">active</option>
                        <option value="qualified">qualified</option>
                        <option value="closed">closed</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
